import { render, staticRenderFns } from "./PaymentConfirmPane.vue?vue&type=template&id=3ca399a0&scoped=true"
import script from "./PaymentConfirmPane.vue?vue&type=script&lang=ts"
export * from "./PaymentConfirmPane.vue?vue&type=script&lang=ts"
import style0 from "./PaymentConfirmPane.vue?vue&type=style&index=0&id=3ca399a0&prod&lang=scss&scoped=true"
import style1 from "./PaymentConfirmPane.vue?vue&type=style&index=1&id=3ca399a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca399a0",
  null
  
)

export default component.exports